import React from 'react'
import { useQuery } from '@tanstack/react-query';
import { getViewsWithDetails } from '../../server-functions/views';
import Table from '../../global/components/YkTable';
import { printTable } from '../../utils/print-pdf';
import { exportToExcel } from '../../utils/export-excel/excel';
import { viewsDetailTableColumns } from '../../global/settings/tableColumns';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import DownloadIcon from '@mui/icons-material/Download';
import RefreshIcon from '@mui/icons-material/Refresh';
import { formatWatchTime } from '../../global/functions';
import dayjs from 'dayjs';
import 'dayjs/locale/he';

dayjs.locale('he');


function ViewsDetail() {
    const {
        data: detailData,
        status: detailStatus,
        refetch: refetchDetail
    } = useQuery({
        queryKey: ['views-detail'],
        queryFn: getViewsWithDetails
    });

    // עיבוד נתוני פירוט
    const processedDetailData = React.useMemo(() => {
        return (detailData || []).map(row => ({
            ...row,
            watchTimeFormatted: formatWatchTime(row.watchTime),
            rangesText: (row.watchedRanges || []).map(r =>
                `${formatWatchTime(r.start)} - ${formatWatchTime(r.end)}`
            ).join(', '),
        }));
    }, [detailData]);

    const detailActions = [
        {
            label: "רענן נתונים",
            icon: <RefreshIcon style={{ fontSize: 18 }} />,
            onClick: refetchDetail
        },
        {
            label: "הפקת אקסל",
            icon: <DownloadIcon style={{ fontSize: 18 }} />,
            onClick: (data) => {
                const mapped = (data || []).map(row => ({
                    'שם משתמש': row.userName,
                    'אימייל': row.userEmail,
                    'טלפון': row.userPhone,
                    'שיעור': row.lessonTitle,
                    'זמן צפייה': row.watchTimeFormatted,
                    'מקטעי צפייה': row.rangesText,
                    'אחוז': `${row.watchPercentage}%`,
                    'תאריך ושעה': row.watchedAt
                        ? dayjs(row.watchedAt?.toDate?.() || row.watchedAt).format('DD/MM/YYYY HH:mm')
                        : '-',
                }));
                exportToExcel(mapped, [], "פירוט צפיות");
            }
        },
        {
            label: "הדפס",
            icon: <LocalPrintshopIcon style={{ fontSize: 18 }} />,
            onClick: (data) => {
                const mapped = (data || []).map(row => ({
                    userName: row.userName,
                    userEmail: row.userEmail,
                    userPhone: row.userPhone,
                    lessonTitle: row.lessonTitle,
                    watchTime: row.watchTimeFormatted,
                    ranges: row.rangesText,
                    percentage: `${row.watchPercentage}%`,
                    watchedAt: row.watchedAt
                        ? dayjs(row.watchedAt?.toDate?.() || row.watchedAt).format('DD/MM/YYYY HH:mm')
                        : '-',
                }));
                const printColumns = [
                    { key: 'userName', title: 'שם משתמש' },
                    { key: 'userEmail', title: 'אימייל' },
                    { key: 'userPhone', title: 'טלפון' },
                    { key: 'lessonTitle', title: 'שיעור' },
                    { key: 'watchTime', title: 'זמן צפייה' },
                    { key: 'ranges', title: 'מקטעים' },
                    { key: 'percentage', title: 'אחוז' },
                    { key: 'watchedAt', title: 'תאריך ושעה' },
                ];
                printTable(mapped, printColumns, "פירוט צפיות");
            }
        },
    ];

    return (
        <Table
            title="פירוט כל הצפיות"
            columns={viewsDetailTableColumns}
            data={processedDetailData}
            loading={detailStatus === 'pending'}
            refetch={refetchDetail}
            actions={detailActions}
        />
    );
}

export default ViewsDetail;
